import Contacto from './contacto'
export default Contacto